<ng-container *ngIf="single === true else multiple">
    <app-select-filter #selectFilter (_onSingleSelectionChange)="selectionChanged($event)"
                       [elements]="elements"
                       [filterElementProcessor]="filter"
                       [noEntriesFoundLabel]="noValueLabel"
                       [parentFormControlName]="parentFormControlName"
                       [parentFormGroup]="parentFormGroup">
        <ng-template let-element='element' template-content>
            <ng-container *ngIf="element.user">
                <app-user-summary-field  [entity]="element.user"></app-user-summary-field> -
            </ng-container>
           {{element.name}} <span style="font-size: 0.7em;">({{element.type.label}})</span>
        </ng-template>
    </app-select-filter>
</ng-container>

<ng-template #multiple>
    <app-multiple-select-filter #multipleSelectFilter
                                (selectionChangedEvent)="multipleSelectionChanged($event)"
                                [elements]="elements"
                                [filterElementProcessor]="filter"
                                [noEntriesFoundLabel]="noValueLabel"
                                [parentFormControlName]="parentFormControlName"
                                [parentFormGroup]="parentFormGroup">
        <ng-template let-element='element' template-content>
            {{element.name}} <span style="font-size: 0.7em;">({{element.type.label}})</span>
        </ng-template>
    </app-multiple-select-filter>
</ng-template>
